import { TokenTraderService } from 'services';
import { Auth } from 'aws-amplify';

export class SessionExpiredError extends Error {
  constructor() {
    super();
    this.message = 'Token has expired';
    this.name = 'TOKEN_EXPIRED';
  }
}

async function refreshToken() {
  const cognitoIdToken = await getCognitoIdToken();
  const { token } = await TokenTraderService.tradeToken(cognitoIdToken);
  setSessionStorage(token);
}

function decodeToken(token) {
  return JSON.parse(atob(token.split('.')[1]));
}

const KEYS = {
  JWT_STRING: 'token_trader_access_token',
  EXPIRATION: 'expiration_token_trader_access_token',
  USER_EMAIL: 'user_email_token_trader_access_token',
  IS_ADMIN: 'user_is_admin_token_trader_access_token',
  USER_SSO_ID: 'user_ssoID_token_trader_access_token',
};

function setSessionStorage(token) {
  const tokenTraderAccessToken = decodeToken(token);
  sessionStorage.setItem(KEYS.JWT_STRING, token);
  sessionStorage.setItem(KEYS.EXPIRATION, tokenTraderAccessToken.exp.toString());
  sessionStorage.setItem(KEYS.USER_EMAIL, tokenTraderAccessToken.email);
  sessionStorage.setItem(KEYS.USER_SSO_ID, tokenTraderAccessToken.sub);
}

function isExpired() {
  if (!sessionStorage.getItem(KEYS.JWT_STRING)) return true;
  const exp = sessionStorage.getItem(KEYS.EXPIRATION);
  if (!exp) return true;
  return Math.floor(Date.now() / 1000) >= parseInt(exp);
}

async function getToken() {
  if (isExpired()) {
    await refreshToken();
  }
  return sessionStorage.getItem(KEYS.JWT_STRING);
}

function getUserEmail() {
  return sessionStorage.getItem(KEYS.USER_EMAIL);
}

function getUserSsoID() {
  return sessionStorage.getItem(KEYS.USER_SSO_ID);
}

function isLoggedIn() {
  return sessionStorage.getItem(KEYS.JWT_STRING) !== undefined && !isExpired();
}

function isUserAdmin() {
  if (!sessionStorage.getItem(KEYS.IS_ADMIN)) return null;
  return sessionStorage.getItem(KEYS.IS_ADMIN) === 'true';
}

function signOut() {
  sessionStorage.removeItem(KEYS.EXPIRATION);
  sessionStorage.removeItem(KEYS.IS_ADMIN);
  sessionStorage.removeItem(KEYS.JWT_STRING);
  sessionStorage.removeItem(KEYS.USER_EMAIL);
  sessionStorage.removeItem(KEYS.USER_SSO_ID);
}

async function getCognitoIdToken() {
  const session = await Auth.currentSession();
  if (!session.isValid()) throw new SessionExpiredError();
  return session.getIdToken().getJwtToken();
}

export default {
  getCognitoIdToken,
  getToken,
  getUserEmail,
  getUserSsoID,
  isLoggedIn,
  isUserAdmin,
  signOut,
  setSessionStorage,
};
